import React, { useEffect, useState, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import "@ag-grid-community/styles/ag-theme-quartz.css";
// import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";

import { ListCards, genericPost } from "../../services/Api";
import cogoToast from "cogo-toast";
import { Breadcrumb, BreadcrumbItem, Table, Button, Tooltip } from "reactstrap";
import { Data } from '@react-google-maps/api';

import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';

const ListingPage = () => {

  // State for modal and history data
  const [modalOpen, setModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [selectedCard, setSelectedCard] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const [searchTerm, setSearchTerm] = useState('');


  //Block and Unblock confirmation Modal functionalities
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCardNumber, setCurrentCardNumber] = useState('');
  const [actionType, setActionType] = useState(''); // 'block' or 'unblock'


  const openConfirmationModal = (cardNumber, action) => {
    setCurrentCardNumber(cardNumber);
    setActionType(action);
    setIsModalOpen(true);
  };


  const handleConfirm = async () => {
  if (actionType === 'block') {
    await blockCard(currentCardNumber);
  } else if (actionType === 'unblock') {
    await unblockCard(currentCardNumber);
  }
  setIsModalOpen(false); // Close modal after action
};

const ConfirmationModal = () => (
  <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
    <ModalHeader toggle={() => setIsModalOpen(false)}>
      Confirm Action
    </ModalHeader>
    <ModalBody>
      {actionType === 'block' ? 
        `Are you sure you want to block the card number ${currentCardNumber}?` : 
        `Are you sure you want to unblock the card number ${currentCardNumber}?`}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={() => setIsModalOpen(false)}>
        Cancel
      </Button>
      <Button color="primary" onClick={handleConfirm}>
        Confirm
      </Button>
    </ModalFooter>
  </Modal>
);

  const officeMap = {
    1: 'South Central',
    2: 'Puntland',
    3: 'Somaliland',
  };

  const statusMap = {
    10000: { text: 'Incomplete', color: 'orange' },
    10001: { text: 'Available', color: 'green' },
    10002: { text: 'Engaged', color: 'amber' },
    10003: { text: 'Blocked', color: 'red' },
  };

  const [rowData, setRowData] = useState([]);
  const [rowSelection, setRowSelection] = useState('multiple'); // Change to 'single' for single row selection
  const [pagination, setPagination] = useState({
    firstPageUrl: '',
    currentPage: 1,
    lastPage: 1,
    lastPageUrl: '',
    perPage: 50,
    from: 0,
    to: 0,
    prevPageUrl: '',
    nextPageUrl: '',
    totalRecords: 0
  });
  const [cards, setCards] = useState([]);

  const modalColumnDefs = [
    { headerName: 'Project Name', field: 'project_name' },
    { headerName: 'Component Name', field: 'component_name' },
    { headerName: 'Beneficiary Name', field: 'beneficiary_name' },
    { headerName: 'Telephone', field: 'telephone' },
    { headerName: 'Age', field: 'age' },
    { headerName: 'District', field: 'district' },
    { headerName: 'Village', field: 'village' },
    { headerName: 'Camp', field: 'camp' },
    { headerName: 'Onboarded At', field: 'Onboarded_at' },
    { headerName: 'Onboarded Status', field: 'Onboarded_status' },
  ];
  

  const columnDefs = useMemo(() => [
    // {
    //   headerName: "Checkbox Cell Editor",
    //   field: "boolean",
    // //   cellEditor: "agCheckboxCellEditor",
    // cellRenderer: 'agCheckboxCellRenderer'
    // },
    { 
      headerName: 'Office', 
      field: 'office_id', 
      valueGetter: params => officeMap[params.data.office_id] || 'Unknown' 
    },
    { headerName: 'Card Number', field: 'card_label' },

    // { headerName: 'Status', field: 'status' },
    { 
      headerName: 'Status', 
      field: 'status',
      sortable: true,
      filter: true,
      cellRendererFramework: (params) => {
        const status = statusMap[params.value] || { text: 'Unknown', color: 'gray' }; // Default to 'Unknown' if status code is not found
        const { text, color } = status;

        return (
          <span style={{ color: color, fontWeight: 'bold' }}>
            <i
              className="fa fa-circle"
              aria-hidden="true"
              style={{ color: color, marginRight: '5px' }}
            ></i>
            {text}
          </span>
        );
      }
    },
    { headerName: 'Date Created', field: 'created_at' },
    // { headerName: 'Office', field: 'office_id' },
    { 
      headerName: 'Actions',
      field: 'action',
      width: 20,
      sortable: false,
      filter: false,
      cellRendererFramework: (params) => {
        const isActive = params.data.active === 1; // Check if the value is 1 (active)
        const Icon = isActive ? "fa fa-times-circle" : "fa fa-times-circle";
        const IconStyle = isActive ? "color:darkgreen" : "color:red";
        const cardNumber = params.data.card_label.replace(/-/g, ''); 
        
        return (
          <span>
            <Button
              className="badge btn-primary"
              onClick={() => handleView(params.data.card_label)}
            >
              
              <i className="fa fa-eye" aria-hidden="true"></i>
            </Button>
            
            &nbsp; &nbsp;

            <Button
          className={`badge ${isActive ? 'btn-danger' : 'btn-success'}`}
          onClick={() => openConfirmationModal(cardNumber, isActive ? 'unblock' : 'block')}
          
        >
          <i className={`fa ${isActive ? 'fa-times-circle' : 'fa-times-circle'}`}></i>
        </Button>
          </span>
        );
      }}

  ], []);

  const defaultColDef = useMemo(() => ({
    editable: false,
    sortable: true,
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
  }), []);

  // Function to fetch data based on URL
  const fetchData = async (url) => {
    try {
      const res = url === '' ? await ListCards() : await genericPost(url, {});
      if (res.status === 200) {
        // console.log(res.data);
        setCards(res.data.data);
        setPagination({
          firstPageUrl: res.data.first_page_url,
          currentPage: res.data.current_page,
          lastPage: res.data.last_page,
          lastPageUrl: res.data.last_page_url,
          perPage: res.data.per_page,
          from: res.data.from,
          to: res.data.to,
          prevPageUrl: res.data.prev_page_url,
          nextPageUrl: res.data.next_page_url,
          totalRecords: res.data.total
        });
      }
    } catch (err) {
      cogoToast.error("Something went wrong, please try again.", {});
    }
  };

  const handleSearch = async () => {
    if (searchTerm.trim() === '') {
      // Reset to the initial page if the search term is cleared
      setPagination(prev => ({ ...prev, currentPage: 1 }));
      fetchData(''); // Fetch initial data
    } else {
      // Fetch data based on the search term
      try {
        const url = "https://staging.irw-ebms-ear.co.ke/api/web/v1/cards/list-cards"
        const cleanedCardNumber = searchTerm.replace(/-/g, '');
        const postData = {
          card_label: String(cleanedCardNumber) // Ensure card_label is a string
        };
        const res = await genericPost(url, postData); // Update with actual endpoint
        if (res.status === 200) {
          setCards(res.data.data);
          setPagination({
            firstPageUrl: res.data.first_page_url,
            currentPage: res.data.current_page,
            lastPage: res.data.last_page,
            lastPageUrl: res.data.last_page_url,
            perPage: res.data.per_page,
            from: res.data.from,
            to: res.data.to,
            prevPageUrl: res.data.prev_page_url,
            nextPageUrl: res.data.next_page_url,
            totalRecords: res.data.total
          });
        } else {
          cogoToast.error(res.message || 'Failed to fetch data');
        }
      } catch (error) {
        cogoToast.error('Failed to search for the card.');
      }
    }
  };
  

  // // Effect to fetch data when component mounts or pagination changes
  useEffect(() => {
    // const url = pagination.currentPage === 1 ? '' : pagination.nextPageUrl;
    const fetchUrl = searchTerm.trim() === '' ? 
    (pagination.currentPage === 1 ? '' : pagination.nextPageUrl) : 
    '';
    fetchData(fetchUrl);
  }, [pagination.currentPage, searchTerm]);


  //View Page
  const fetchHistory = async (cardNumber) => {
    const cleanedCardNumber = cardNumber.replace(/-/g, '');
    setSelectedCard(cardNumber);
    const postData = {
      card_label: String(cleanedCardNumber) // Ensure card_label is a string
    };
    const url = "https://staging.irw-ebms-ear.co.ke/api/web/v1/br/card-history"
    try {
      const response = await genericPost(url, postData);
      // setHistoryData(data);
      if (response.status === 200) {
        setHistoryData(response.data.data); 
        // Assume historyData is an array
        setModalMessage(response.data.message); // Clear any previous error message
      }
       else {
        setHistoryData([]); // Clear previous data if there's an error
        setModalMessage(  'An error occurred.'); // Show error message
      }
      // setModalOpen(true);
      setModalOpen(true); // Open the modal to show history
    } catch (error) {
      cogoToast.error("Failed to fetch card history.");
    }
  };

  const handleView = (cardNumber) => {
    // setSelectedCard(cardNumber);
    // setModalMessage(`Would you like to see the history of ${cardNumber}?`);
    fetchHistory(cardNumber)
    setModalOpen(true);
  };
  
  // Handler for page changes
  const handlePageChange = (direction) => {
    if (direction === 'next' && pagination.nextPageUrl) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage + 1
      }));
    } else if (direction === 'prev' && pagination.prevPageUrl) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage - 1
      }));
    }
  };


  const blockCard = async (cardNumber) => {
    try {
      // Call the API endpoint to block the card
      const postData = {
        card_number: String(historyData.cardlabel === cardNumber?historyData.card_number:'') // Ensure card_label is a string
      };
      const url = "https://staging.irw-ebms-ear.co.ke/api/web/v1/cards/block-card"
      const response = await genericPost(url, postData);
      if (response.status === 200) {
        cogoToast.success('Card blocked successfully.');
        fetchData(''); // Refresh the data
      } else {
        cogoToast.error(response.message);
      }
    } catch (error) {
      cogoToast.error('An error occurred while blocking the card.');
    }
  };
  
  const unblockCard = async (cardNumber) => {
    try {
      const postData = {
        card_number: String(historyData.cardlabel === cardNumber?historyData.card_number:'') // Ensure card_label is a string
      };
      const url = "https://staging.irw-ebms-ear.co.ke/api/web/v1/cards/unblock-card"
      const response = await genericPost(url, postData);
      if (response.status === 200) {
        cogoToast.success('Card unblocked successfully.');
        fetchData(''); // Refresh the data
      } else {
        cogoToast.error(response.message);
      }
    } catch (error) {
      cogoToast.error('An error occurred while unblocking the card.');
    }
  };
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ marginBottom: 4, textAlign: 'left', padding: '0px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
  {/* Search Functionality */}
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <input
      type="text"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="Enter card number to search"
      style={{ marginRight: '10px' }}
    />
    <Button color="primary" onClick={handleSearch}>
      Search
    </Button>
    <Button
      color="secondary"
      onClick={() => {
        setSearchTerm(''); // Clear search term
        setPagination(prev => ({ ...prev, currentPage: 1 })); // Reset to first page
      }}
      style={{ marginLeft: '10px' }}
    >
      Clear Search
    </Button>
  </div>


       {/* Pagination Controls */}
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <button
      className="btn btn-primary"
      onClick={() => handlePageChange('prev')}
      disabled={!pagination.prevPageUrl}
      style={{ marginRight: '10px' }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 6l-6 6l6 6"></path>
      </svg>
      Previous
    </button>

    <span style={{ margin: '0 10px' }}>
      Showing data: {pagination.from} to {pagination.to}
    </span>
    <span style={{ margin: '0 10px' }}>
      Page {pagination.currentPage} of {pagination.lastPage}
    </span>

    <button
      className="btn btn-primary"
      onClick={() => handlePageChange('next')}
      disabled={!pagination.nextPageUrl}
      style={{ marginLeft: '10px' }}
    >
      Next
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 6l6 6l-6 6"></path>
      </svg>
    </button>

    </div>

</div>

      </div>

      <ConfirmationModal />

      <div className="ag-theme-alpine" style={{ flex: 1 }}>
        <AgGridReact
          rowData={cards}
          columnDefs={columnDefs}
          // rowSelection={rowSelection}
          domLayout="autoHeight"
          defaultColDef={defaultColDef}
          
        />
      </div>
      {/* Modal for showing card history */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
  <ModalHeader toggle={() => setModalOpen(false)}>Card History</ModalHeader>
  <ModalBody>
    
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
      <AgGridReact
        rowData={historyData}
        columnDefs={modalColumnDefs}
        defaultColDef={{
          sortable: true,
          filter: true,
          flex: 1,
          minWidth: 200,
        }}
      />
    </div>
    
  </ModalBody>
</Modal>

    </div>
  );
};

export default ListingPage;
